function getFullName(user) {
    const { firstName , lastName  } = user;
    if (typeof firstName === "string" && typeof lastName === "string") return `${firstName} ${lastName}`;
    else if (typeof firstName === "string" && typeof lastName !== "string") return firstName;
    else return lastName || "Someone";
}
export default getFullName;
